import type { ReactNode } from 'react';
import BulletinSection from '@/components/common/BulletinSection';

interface HomeSectionProps {
  readonly title: ReactNode;
  /** Ссылка справа от заголовка, например «Все сделки». */
  readonly link?: { readonly to: string; readonly label: string };
  readonly children: ReactNode;
}

/** Раздел «Главной»: общий раздел «Бюллетеня», строки начинаются сразу под линией. */
export default function HomeSection({ title, link, children }: HomeSectionProps) {
  return (
    <BulletinSection title={title} link={link}>
      {children}
    </BulletinSection>
  );
}
